import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import DashboardFilter from "../../pages/NHQ-Dashboard-Filter/DashboardFilter";
import {
  triggerFetchRechargeDistribution,
  triggerFetchTimeStamp,
  triggerRechargeDistributionCsv,
  unsetRun,
} from "../../redux/actions";
import { hideAlertRecharge } from "../../redux/actions/rechargeSalesAction";
import {
  triggerShowHeader,
  unsetPayoutDashboard,
} from "../../redux/actions/action";
import { getPartnerRoleID, validatePartnerRoleType } from "../../utils/common";
import DashboardFilter from "../../containers/dashboardFilter/index";
import RechargeSalesComponents from "./rechargeSalesComponents";
import { triggerIsDashboardAccessible } from "../../redux/actions";
import Spinner from "../../components/presentationals/Spinner";
import CustomLandingBody from "../../components/customLandingBody";
import Alert from "../../components/alert";

class RechargeSales extends React.Component {
  constructor() {
    super();
    this.state = {
      showAlert: null,
      dashboardName: "Recharge Sales",
    };
  }

  callTimeStamp(props) {
    const moduleName =
      props.getAllAPI && props.getAllAPI.data && props.getAllAPI.data.content
        ? props.getAllAPI.data.content.filter(
            (item) => item.moduleName.toLowerCase() === "recharge sales"
          )[0].moduleName
        : null;
    let timeStampObj = {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        moduleName: moduleName,
        partnerRole: getPartnerRoleID(
          props.filterValue.selectedPartnerRoleName
        ),
      },
    };
    this.props.triggerFetchTimeStamp(timeStampObj, moduleName);
  }

  componentDidMount() {
    this.props.unsetPayoutDashboard();
    this.props.unsetRun();

    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = this.props.tilesData?.data?.content?.filter(
      (obj) => obj.moduleName === this.state.dashboardName
    )[0].isTestingActive;

    //if it is true, then check if this loggedin user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = this.props.dashboardAccessibility?.data?.filter(
        (currentDashboard) =>
          currentDashboard.dashboard === this.state.dashboardName
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return this.setState({
          showAlert: true,
        });
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        this.setState({
          showAlert: false,
        });

        this.props.triggerShowHeader(true);
        if (
          this.props.getAllAPI &&
          this.props.getAllAPI.data &&
          this.props.getAllAPI.data.content
        ) {
          this.callTimeStamp(this.props);
        }
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: this.state.dashboardName,
            userType: this.props.filterValue.site,
          },
          domainId:
            this.props.filterValue.orgId !== ""
              ? this.props.filterValue.orgId
              : this.props.filterValue?.agentId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return this.props.triggerIsDashboardAccessible(obj, (res) => {
          //if the response shows access enabled as false, go to home page and show alert
          if (!res.content.accessEnabled) {
            return this.setState({
              showAlert: true,
            });
          } else {
            this.setState({
              showAlert: false,
            });

            this.props.triggerShowHeader(true);
            if (
              this.props.getAllAPI &&
              this.props.getAllAPI.data &&
              this.props.getAllAPI.data.content
            ) {
              this.callTimeStamp(this.props);
            }
          }
        });
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      this.setState({
        showAlert: false,
      });

      this.props.triggerShowHeader(true);
      if (
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
      ) {
        this.callTimeStamp(this.props);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.getAllAPI &&
      this.props.getAllAPI.data &&
      !this.props.getAllAPI.data.content &&
      nextProps.getAllAPI.data.content
    ) {
      this.callTimeStamp(nextProps);
    }
  }

  render() {
    return this.state.showAlert === null ? (
      <Spinner />
    ) : this.state.showAlert ? (
      <CustomLandingBody
        showAlert={this.state.showAlert}
        dashboardName={this.state.dashboardName}
      />
    ) : (
      <div className="container-fluid">
        {this.props.partnerRoleType &&
        validatePartnerRoleType(this.props.partnerRoleType).showFilters ? (
          <DashboardFilter dashboard={this.state.dashboardName} />
        ) : null}
        <h2
          className="pagetitle wow fadeInUp"
          data-wow-delay=".5s"
          data-wow-duration="0.7s"
        >
          Recharge Sales
        </h2>
        <Alert
          showAlert={this.props.showAlert}
          hideAlert={this.props.hideAlertRecharge}
        />
        {this.props.shouldRun ? (
          <RechargeSalesComponents
            triggerFetchRechargeDistribution={
              this.props.triggerFetchRechargeDistribution
            }
            triggerRechargeDistributionCsv={
              this.props.triggerRechargeDistributionCsv
            }
            getAllAPI={this.props.getAllAPI}
            distributionObj={this.props.distributionObj}
            distCsvObj={this.props.distCsvObj}
            startDate={this.props.headerSelectedDateFrom}
            endDate={this.props.headerSelectedDateTo}
            valueUnit={this.props.headerUnit}
            filterValue={this.props.filterValue}
            timestamp={this.props.timestamp && this.props.timestamp.data}
          />
        ) : (
          <div
            className="whitebox wow fadeInUp text-center disclaimer p-4 rounded"
            data-wow-delay=".6s"
            data-wow-duration="0.7s"
          >
            <ul>
              <li>{window.CLICK_RUN_1}</li>
              {this.props.partnerRoleType &&
              validatePartnerRoleType(this.props.partnerRoleType)
                .showFilters ? (
                <li>{window.CLICK_RUN_2}</li>
              ) : null}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let {
    distributionObj,
    distCsvObj,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    headerUnit,
    showAlert,
  } = state.rechargeSalesReducer;

  let {
    getAllAPI,
    filterValue,
    partnerRoleType,
    timestamp,
    tilesData,
    shouldRun,
  } = state.homeReducer;

  let { dashboardAccessibility } = state.dashboardAccessibilityReducer;

  return {
    getAllAPI,
    distributionObj,
    distCsvObj,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    headerUnit,
    filterValue,
    partnerRoleType,
    timestamp,
    tilesData,
    dashboardAccessibility,
    showAlert,
    shouldRun,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      triggerFetchRechargeDistribution,
      triggerRechargeDistributionCsv,
      triggerShowHeader,
      triggerFetchTimeStamp,
      triggerIsDashboardAccessible,
      hideAlertRecharge,
      unsetPayoutDashboard,
      unsetRun,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(RechargeSales);
